import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbDate, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';

export type DatePickerStatus = 'valid' | 'invalid';
@Component({
    selector: 'app-ngb-date-picker',
    templateUrl: './date-picker.component.html',
    styleUrls: ['./date-picker.component.scss'],
    standalone: false
})
export class NgbDatePickerComponent {
  @Input() date?: NgbDateStruct;
  @Input() minDate?: NgbDateStruct;
  @Input() maxDate?: NgbDateStruct;
  @Input() isHighlightTodayEnabled = false;
  @Input() isWeekendEnabled = true;
  @Input() isButtonDisabled = false;
  @Input() isRequired = false;
  @Input() disabled = false;
  @Input() icon = 'fal fa-calendar-alt';
  @Input() id = 'dateInput';
  @Input() name = 'dateInput';
  @Output() dateSelectionEvent: EventEmitter<NgbDate> = new EventEmitter();
  @Output() statusChangeEvent: EventEmitter<DatePickerStatus> =
    new EventEmitter();

  isDateDisabled = (date: NgbDate) =>
    !this.isWeekendEnabled && this.isWeekend(date);

  isToday = (date: NgbDate) => {
    const today = moment().toDate();
    return (
      date.day == today.getDate() &&
      date.month == today.getMonth() + 1 &&
      date.year == today.getFullYear()
    );
  };

  isWeekend(date: NgbDate) {
    const day = moment({
      year: date.year,
      month: date.month - 1,
      day: date.day,
    })
      .toDate()
      .getDay();

    return day == 6 || day == 0; //saturday || sunday
  }

  onDateSelection(date: NgbDate | undefined, isValid = false) {
    if (isValid) {
      this.dateSelectionEvent.emit(date);
      this.statusChangeEvent.emit('valid');
    } else {
      this.statusChangeEvent.emit('invalid');
    }
  }
}
